import getOffset from './helpers/get_offset';

const stickyHeader = (value = 292) => {
	const header = document.querySelector('.header');

	let offset = value;

	if (!Number.isInteger(value)) {
		const element = document.querySelector(value);

		offset = getOffset(element);
	}


	window.onscroll = () => {
		const scrollY = window.scrollY;

		if (scrollY > 110) {
			header.classList.add('header--transform');
		} else {
			header.classList.remove('header--transform');
		}

		if (scrollY > 150) {
			header.classList.add('header--fixed');
		} else {
			header.classList.remove('header--fixed');
		}

		if (scrollY > offset + 40) {
			header.classList.add('header--sticky');
		} else {
			header.classList.remove('header--sticky');
		}
	};
};

export default stickyHeader;


// WEBPACK FOOTER //
// ./assets/js/partials/sticky_header.js